"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatDescription = getStatDescription;
const interfaces_1 = require("@lotr/interfaces");
const statValues = {
    [interfaces_1.Stat.STR]: ['Puny', 'Weak', 'Average', 'Strong', 'Muscular', 'Herculean'],
    [interfaces_1.Stat.DEX]: [
        'Uncoordinated',
        'Clumsy',
        'Average',
        'Handy',
        'Deft',
        'Artemesian',
    ],
    [interfaces_1.Stat.AGI]: ['Slow', 'Stiff', 'Average', 'Spry', 'Nimble', 'Hermesian'],
    [interfaces_1.Stat.INT]: ['Brainless', 'Dense', 'Average', 'Sharp', 'Smart', 'Aethene'],
    [interfaces_1.Stat.WIS]: ['Foolish', 'Silly', 'Average', 'Shrewd', 'Wise', 'Sagacious'],
    [interfaces_1.Stat.WIL]: [
        'Infirmed',
        'Easily-shaken',
        'Average',
        'Determined',
        'Resolved',
        'Resolute',
    ],
    [interfaces_1.Stat.CON]: ['Frail', 'Weakened', 'Average', 'Fit', 'Well-built', 'Robust'],
    [interfaces_1.Stat.LUK]: [
        'Ill-fated',
        'Unlucky',
        'Average',
        'Favorable',
        'Fortunate',
        'Erna',
    ],
    [interfaces_1.Stat.CHA]: [
        'Abhorrent',
        'Ugly',
        'Average',
        'Pleasant',
        'Attractive',
        'Bardacious',
    ],
};
function getStatDescription(stat, value = 1) {
    const value5 = Math.floor(value / 5);
    const array = statValues[stat] ?? [];
    return array[Math.min(value5, array.length - 1)] ?? '';
}
